import { useEffect, useState } from 'react';

const formatter = (() => {
  try {
    return new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Dubai',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false,
    });
  } catch {
    return null;
  }
})();

/** Live clock for Dubai. */
export default function LocalTime() {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  if (!formatter) return null;
  return <time dateTime={now.toISOString()}>{formatter.format(now)}</time>;
}
